import Api from '@/api'

import Auth from '@/modules/auth'
import Loop from '@/modules/loop'

const User = {
    
    async refreshSubscriptions(asyncFetchMeantime, doneFunction) {
    
        return Loop.start(Api.newsletters.get, asyncFetchMeantime, doneFunction)
            .catch(() => {})
    },

    async sortSubscriptions(subscriptions) {
        return subscriptions
            .filter(item => !item.invalidGrant)
            .sort((itemA, itemB) => Number(!!itemB.notSeen) - Number(!!itemA.notSeen)) //sort in order true and false/undefined
    },
    
    getUserAsync() {

        return Api.user.getUser()
            .catch(() => {
                Auth.disconnect()
            })
    },

    async getUserSync() {
        return await Api.user.getUser()
    },


    async getSortLaterList() {
        const result = await Api.newsletters.getSortLater()

        if(result && result.subscriptions && result.subscriptions.length) {
            return result.subscriptions
        } else {
            return []
        }
    }
}


export default User
